export default __webpack_public_path__ + "static/medium-6b3c86bef745f4d513c4e078fdb54d1d.svg";